$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 10) {
        $(".ic-header").addClass("ic-fixed-header-bg");
    } else {
        $(".ic-header").removeClass("ic-fixed-header-bg");
    }
});


// 自己添加的代码
(function() {
  function optimizeImages() {
    const desc = document.querySelector('.product-description.rte');
    if (!desc) {
      console.log("❌ 未找到 .product-description.rte 容器");
      return;
    }

    const images = desc.querySelectorAll('img');
    images.forEach(img => {
        // 检查图片是否属于视频预览图
       // 如果图片在 video-wrapper-lite 类名之下，或者图片链接包含 youtube，则跳过放大逻辑
        const isVideoImage = img.closest('.video-wrapper-lite') || img.src.includes('ytimg.com');
  
       if (isVideoImage) {
         return; // 跳过当前这张图，不执行下面的优化和点击逻辑
       }
      if (img.dataset.processed) return;

      const rawSrc = img.getAttribute('src');
      if (!rawSrc) return;

      // 1. 强制懒加载
      img.setAttribute('loading', 'lazy');

      // 2. 替换为缩略图 (480x 足够手机端清晰显示且体积极小)
      if (rawSrc.includes('cdn.shopify.com') && !rawSrc.includes('_480x')) {
        let newSrc = rawSrc.replace(/(\.(?:jpg|jpeg|png|webp|gif))(\?v=.*)?$/i, '_480x$1$2');
        img.src = newSrc;
      }

      // 3. 点击放大逻辑
      img.style.cursor = 'zoom-in';
      img.onclick = function(e) {
        e.preventDefault();
        createLightbox(rawSrc);
      };

      img.dataset.processed = "true";
    });
  }

  function createLightbox(src) {
    let lb = document.getElementById('custom-lightbox');
    if (!lb) {
      lb = document.createElement('div');
      lb.id = 'custom-lightbox';
      lb.setAttribute('style', 'display:none; position:fixed; z-index:999999; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.9); align-items:center; justify-content:center; cursor:zoom-out;');
      lb.innerHTML = '<img style="max-width:95%; max-height:95%; object-fit:contain;">';
      document.body.appendChild(lb);
      lb.onclick = () => lb.style.display = 'none';
    }
    lb.querySelector('img').src = src;
    lb.style.display = 'flex';
  }

  // 这里的逻辑处理：DOM加载后执行，并针对可能存在的异步加载进行轮询
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', optimizeImages);
  } else {
    optimizeImages();
  }
  
  // 针对一些主题的动态渲染，多检查几次
  setTimeout(optimizeImages, 1500);
  setTimeout(optimizeImages, 3000);
})();

document.addEventListener("click", function(e) {
  const wrapper = e.target.closest('.product-description.rte .video-wrapper-lite');
  if (wrapper) {
    const videoId = wrapper.dataset.videoId;
    wrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
  }
});

